class SizeChartOverlay extends HTMLElement {
  constructor() {
    super();
    this.closeOverlayHandler = this.close.bind(this);
    this.closeButtonHandler = this.close.bind(this);
    this.addClubToCartHandler = this.addClubToCart.bind(this);
  }

  connectedCallback() {
    this.setupEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  setupEventListeners() {
    // Set up overlay click to close the component
    this.overlay = this.querySelector('.panel-overlay');
    this.overlay?.addEventListener('click', this.closeOverlayHandler);

    // Set up close button
    this.closeButton = this.querySelector('.drawer_close');
    this.closeButton?.addEventListener('click', this.closeButtonHandler);

    //.add_club_to_cart
    this.addClubToCartBtn = this.querySelector('.add_club_to_cart');
    this.addClubToCartBtn?.addEventListener('click', this.addClubToCartHandler); 
  }

  removeEventListeners() {
    this.overlay?.removeEventListener('click', this.closeOverlayHandler);
    this.closeButton?.removeEventListener('click', this.closeButtonHandler);
    this.addClubToCartBtn?.removeEventListener('click', this.addClubToCartHandler);
  }

  addClubToCart() {
    // Add club to cart logic here
    this.close();
    window.__abc.addClubMembershipToCart();
  }

  open(triggeredBy) {
    if (triggeredBy) {
      this.setActiveElement(triggeredBy);
    }

    this.classList.add('active');

    // Trap focus inside the component using the global trapFocus function
    const containerToTrapFocusOn = this.querySelector('.drawer__inner');
    const focusElement = containerToTrapFocusOn || this.querySelector('.drawer_close');
    if (typeof trapFocus === 'function' && containerToTrapFocusOn) {
      trapFocus(containerToTrapFocusOn, focusElement);
    }

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');

    // Remove focus trap
    if (typeof removeTrapFocus === 'function' && this.activeElement) {
      removeTrapFocus(this.activeElement);
    }

    document.body.classList.remove('overflow-hidden');

    if (this.activeElement) {
      this.activeElement.focus();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('size-chart-overlay', SizeChartOverlay);




document.addEventListener('DOMContentLoaded', () => {
  const modalButtons = document.querySelectorAll('button[data-modal-target="size-chart-overlay"]');
  modalButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      const overlay = document.querySelector('size-chart-overlay');

      if (overlay && typeof overlay.open === 'function') {
        overlay.open(button); 
      }
    });
  });
});